import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { Path } from '@plvs/const'
import { openIntercom } from '@plvs/respawn/features/analytics/intercom/intercom'
import { NxTypography } from '@playvs-inc/nexus-components'
import { Box, useBreakpointSm } from '@plvs/respawn/features/layout'
import { RouterLink } from '@plvs/respawn/features/route'
import { Link } from '../link'

const useStyles = makeStyles({
  supportText: {
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
  },
})

export interface GetSupportProps {
  title?: string
  link: string
  linkTitle: string
  showSignup?: boolean
}
export const GetSupport: React.FC<GetSupportProps> = ({
  title,
  link,
  linkTitle,
  showSignup = false,
}) => {
  const isSm = useBreakpointSm()
  const classes = useStyles()
  const justShowSignup = isSm && showSignup
  const shouldOpenIntercom = link === 'intercom'
  return (
    <>
      {!justShowSignup && (
        <Box display="flex" flexDirection="row">
          {title && (
            <Box pl={1} pr={1}>
              <NxTypography>{title} </NxTypography>
            </Box>
          )}
          {shouldOpenIntercom ? (
            <NxTypography
              className={classes.supportText}
              onClick={openIntercom}
            >
              {linkTitle}
            </NxTypography>
          ) : (
            <Link
              className={classes.link}
              rel="noopener"
              target="_blank"
              to={link}
            >
              <NxTypography className={classes.supportText}>
                {linkTitle}
              </NxTypography>
            </Link>
          )}
        </Box>
      )}
      {showSignup && (
        <Box pl={5}>
          <Button
            color="primary"
            component={RouterLink}
            data-testid="sign-up-button"
            to={Path.Registration}
            variant="contained"
          >
            Sign up
          </Button>
        </Box>
      )}
    </>
  )
}
